var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-play-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,7.4L7.3,1.8C6.9,1.6,6.4,1.4,5.9,1.4c-1.6,0-2.8,1.2-2.8,2.8v11.3c0,0.5,0.1,1,0.4,1.4 c0.4,0.6,1,1.1,1.7,1.3c0.2,0.1,0.5,0.1,0.7,0.1c0.5,0,1-0.1,1.4-0.4l9.7-5.6c0.4-0.3,0.7-0.6,1-1C18.7,10,18.3,8.2,17,7.4z  M16.3,10.3c-0.1,0.2-0.2,0.2-0.3,0.3l-9.7,5.6c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.1-0.1-0.2-0.1-0.4V4.3 c0-0.5,0.3-0.8,0.8-0.8c0.2,0,0.3,0,0.4,0.1l9.7,5.6l0,0C16.3,9.4,16.5,9.9,16.3,10.3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOutline);
export default __webpack_public_path__ + "static/media/playOutline.0a0360cca37eaf3e2ab11aa4f8172439.svg";
export { ForwardRef as ReactComponent };